export const hubsConfig = {
  hubs: [
    {
        id: 'help-spain',
        slug: 'help-spain',
        title: 'Help in Spain – Emergency & Support Guide',
        shortTitle: 'Get Help',
        tagline: 'Comprehensive support directory for everyone in Spain',
        description: 'Emergency numbers, social services, legal aid, healthcare access, housing support and more. Find help based on who you are and what you need.',
        metaDescription: 'Help & Support in Spain: Emergency numbers (112, 016), social services, legal aid, healthcare access, housing support, disability services, migrant support, and community resources.',
        intro: 'Whether you\'re a resident, citizen, expat, or visitor, this comprehensive directory connects you with the right support services, emergency contacts, and practical help you need in Spain.',
        featuredArticles: ['001', '003', '004', '006', '007'],
        featuredTools: ['residency-route-finder', 'iprem-calculator', 'smi-calculator'],
        faqs: [
          {
            question: 'What emergency numbers should I know in Spain?',
            answer: '112 for general emergencies (police, fire, medical), 091 for police, 062 for Guardia Civil, 080/085 for fire services, 061 for health emergencies (regional), and 016 for gender violence (confidential). Always say your location first.'
          },
          {
            question: 'How do I access social services in Spain?',
            answer: 'Contact your local Ayuntamiento (Town Hall) to book an appointment with Servicios Sociales. Bring your ID, padrón (residence registration), income proof, and relevant documents. They can help with housing aid, family support, dependency services, and emergency assistance.'
          },
          {
            question: 'What healthcare options are available?',
            answer: 'If you work in Spain, you can access the public healthcare system (SNS) with a tarjeta sanitaria. Otherwise, you may need private insurance or the Convenio Especial (paid access to public healthcare). Start at your local Centro de Salud with your documents.'
          },
          {
            question: 'How can I get legal aid in Spain?',
            answer: 'Apply for a duty lawyer (turno de oficio) at your local Bar Association (Colegio de Abogados) if you meet income requirements. Victim support offices also provide legal and psychological assistance for specific cases.'
          },
          {
            question: 'Where can I find housing support?',
            answer: 'Check with your regional government for rent subsidies (ayudas al alquiler), contact your Ayuntamiento for municipal mediation, and reach out to Servicios Sociales for emergency accommodation if needed.'
          }
        ],
        relatedHubs: ['visas-permits', 'paperwork', 'taxes'],
        entityIds: ['help-spain', 'emergency-numbers', 'social-services', 'legal-aid', 'healthcare-access', 'housing-support', 'disability-services', 'migrant-support']
      },
    {
             id: 'visas-permits',
       slug: 'visas-permits',
       title: 'Visas & Permits',
       shortTitle: 'Visas & Permits',
      tagline: 'Immigration and residency options',
      description: 'Complete guides for all Spanish visa types including Non-Lucrative (NLV), Digital Nomad (DNV), Student, Job Seeker and family visas. Find the right permit for your situation.',
      metaDescription: 'Spain visas & residency 2025: Digital Nomad, Non-Lucrative, Job Seeker, Student, Entrepreneur. Eligibility, documents, fees, timelines—plus route finder & calculators.',
      intro: 'Planning to work remotely, retire, study or join family in Spain? Compare visas and permits by requirements, documents and timelines or use the Route Finder to find the right permit for your situation.',
      featuredArticles: ['002', '007', '015', '021', '024', '008', '014'],
      featuredTools: ['residency-route-finder', 'iprem-calculator', 'smi-calculator'],
      comparison: {
        title: 'Visa Comparison',
        items: [
          {
            name: 'Non-Lucrative Visa',
            who: 'Retirees, passive income',
            applyFrom: 'Outside Spain',
            duration: '1 year, renewable',
            minIncome: '≥400% IPREM. 2025: €2,400/mo main; €600/mo per dependent',
            workRights: 'No work allowed',
            keyDocs: 'Health insurance, bank statements',
            fees: 'Consular fees vary by country, NIE €9.84, TIE €16.08–€21.87'
          },
          {
            "name": "Digital Nomad Visa",
            "who": "Remote workers (employees or freelancers)",
            "applyFrom": "Outside Spain (visa, 1 year) or in Spain (residence, up to 3 years)",
            "duration": "1 year visa; up to 3 years residence permit (renewable 2 years)",
            "minIncome": "≥200% SMI. 2025: €2,368/mo (14 pays) ≈ €2,763/mo (12 pays)",
            "workRights": "Employees: only for non-Spanish employers. Self-employed: up to 20% of activity for Spanish clients",
            "keyDocs": "Employment contract or freelance contracts, private health insurance",
            "fees": "Consular fees vary by country, NIE €9.84, TIE €16.08–€21.87"
          },
          {
            "name": "Job Seeker Visa",
            "who": "Spanish descendants or shortage-occupation candidates",
            "applyFrom": "Outside Spain",
            "duration": "12 months, non-renewable",
            "minIncome": "Sufficient means (set annually by Ministerial Order)",
            "workRights": "No work allowed until converted to a work permit",
            "keyDocs": "Proof of descent or eligibility, bank statements",
            "fees": "Consular fees vary by country, NIE €9.84, TIE €16.08–€21.87"
          },
          {
            "name": "Graduate Job Seeker Authorization",
            "who": "Non-EU graduates of Spanish universities",
            "applyFrom": "Inside Spain",
            "duration": "Up to 24 months, non-renewable",
            "minIncome": "Sufficient means (practice ≈100% IPREM = €7,200/year in 2025)",
            "workRights": "No work allowed until converted to a work permit",
            "keyDocs": "Degree certificate, declaration of means, health insurance",
            "fees": "No consular fee; TIE €16.08–€21.87"
          },
          {
            name: 'Work Visa',
            who: 'Employees with job offers',
            applyFrom: 'Outside Spain',
            duration: '1 year, renewable',
            minIncome: 'Salary per SMI/convenio; no fixed threshold',
            workRights: 'Full work rights',
            keyDocs: 'Employment contract, employer docs',
            fees: 'Consular fees vary by country, NIE €9.84, TIE €16.08–€21.87'
          },
          {
            name: 'Self-Employed',
            who: 'Freelancers, business owners',
            applyFrom: 'Outside Spain',
            duration: '1 year, renewable',
            minIncome: 'Business plan + funds',
            workRights: 'Full work rights',
            keyDocs: 'Business plan, financial proof',
            fees: 'Consular fees vary by country, NIE €9.84, TIE €16.08–€21.87'
          },
          {
            name: 'Student Visa',
            who: 'Full-time students',
            applyFrom: 'Outside Spain',
            duration: 'Course length',
            minIncome: '€7,200/year',
            workRights: 'Up to 30 hrs/week under 2025 rules',
            keyDocs: 'Enrollment letter, accommodation',
            fees: 'Consular fees vary by country, NIE €9.84, TIE €16.08–€21.87'
          }
        ]
      },
      faqs: [
        {
          "question": "Which visa allows me to work in Spain?",
          "answer": "The Digital Nomad Visa allows remote work for non-Spanish employers (and limited 20% work for Spanish clients). The Work Visa and Self-Employed Visa grant full work rights. The Job Seeker pathways (graduate authorization or consular visa) do not allow work until you secure a job and convert your residence status."
        },
        {
          "question": "What is the easiest way to get residency in Spain?",
          "answer": "It depends on your profile: Non-Lucrative Visa for retirees or financially independent people, Digital Nomad Visa for remote workers, Work Visa for those with a Spanish job offer, Student Visa for those studying in Spain or the Graduate Job Seeker Authorization for recent university graduates in Spain."
        },
        {
          "question": "How long does visa processing take?",
          "answer": "Processing times vary by visa type: Non-Lucrative Visa (2–3 months), Digital Nomad Visa (UGE-CE fast-track 15–45 days), Job Seeker Visa abroad (1–2 months), Graduate Job Seeker Authorization in Spain (1–3 months), Work Visa (1–3 months). Always apply well in advance."
        },
        {
          question: 'Do I need to speak Spanish to get a visa?',
          answer: 'No, Spanish language proficiency is not required for most visa applications. However, learning Spanish will help with daily life and integration.'
        }
      ],
      relatedHubs: ['paperwork', 'taxes'],
      entityIds: ['visas-permits', 'nlv', 'dnv', 'job-seeker-visa', 'rd-1155-2024']
    },
    {
      id: 'paperwork',
      slug: 'paperwork',
      title: 'Paperwork',
      shortTitle: 'Paperwork',
      tagline: 'Essential admin after arrival',
      description: 'Step-by-step guide to essential documents: NIE, TIE, empadronamiento, Cl@ve, and administrative tasks. Complete your Spanish bureaucracy efficiently.',
      metaDescription: 'NIE, TIE, empadronamiento, Cl@ve—Spain paperwork for foreign residents with step-by-step checklists, appointments and forms.',
      intro: 'In your first 30–60 days, complete NIE, padrón, TIE, Cl@ve. Follow checklists and book appointments with our guides.',
      featuredArticles: ['001', '018', '028', '013', '016', '033'],
      featuredTools: ['driving-license-checker'],
      comparison: {
        title: 'NIE vs TIE: What\'s the Difference?',
        items: [
          {
            name: 'NIE (Número de Identidad de Extranjero)',
            purpose: 'Foreign identification number',
            format: 'X/Y/Z + 7 digits + letter',
            validity: 'Permanent number, 3-month certificate',
            whenNeeded: 'Opening a bank account, buying property, contracts, taxes',
            cost: '2025: €9.84 - (Modelo 790 012)'
          },
          {
            name: 'TIE (Tarjeta de Identidad de Extranjero)',
            purpose: 'Physical residence permit card with photo, NIE and support number',
            format: 'Plastic card with photo',
            validity: '1-5 years, renewable with your residence permit',
            whenNeeded: 'Legal residence proof, entering Spain, identification in Spain',
            cost: '2025: €16.08–€21.87 (Modelo 790 012, depending on permit type)'
          }
        ]
      },
      faqs: [
        {
          question: 'NIE vs TIE: which do I need first?',
          answer: 'You need an NIE first for most transactions. The TIE is your residence permit card, issued after your visa is approved.'
        },
        {
          question: 'What are the deadlines after arrival?',
          answer: 'You must register at the town hall and apply for empadronamiento within 3 months of arrival, TIE within 1 month of entry and health registration as soon as possible.'
        },
        {
          "question": "Can I get an NIE without a visa?",
          "answer": "Yes. You can request a non-resident NIE through a Spanish consulate abroad or in Spain. This allows you to carry out financial or legal transactions (like buying property, opening a bank account or setting up a company) but it does not grant residency or the right to stay long-term."
        },
        {
          question: 'How long does document processing take?',
          answer: 'NIE certificate: 1-3 weeks, TIE: 1-2 months, empadronamiento: same day, health registration: 1-4 weeks.'
        }
      ],
      relatedHubs: ['visas-permits', 'lifestyle'],
      entityIds: ['paperwork', 'nie', 'tie', 'empadronamiento', 'clave', 'nie-vs-tie', 'numero-de-soporte', 'modelo-790-012']
    },
    {
      id: 'finance',
      slug: 'finance',
      title: 'Finance',
      shortTitle: 'Finance',
      tagline: 'Banking, insurance, and money management',
      description: 'Complete guide to managing your money in Spain: banking, insurance, budgeting, international transfers, and financial planning for expats.',
      metaDescription: 'Banking in Spain for expats: open accounts, insurance, budgeting, transfers. Tools to estimate savings and plan costs.',
      intro: 'Open a Spanish bank account, set up insurance, and manage international transfers. Use our tools to estimate savings and plan your financial future in Spain.',
      featuredArticles: ['022', '010', '012', '030'],
      featuredTools: ['savings-calculator'],
      comparison: {
          title: "Banking Options in Spain",
        items: [
          {
            name: "Traditional Banks",
            features: "Full services, physical branches, Spanish IBAN",
            fees: "Typically €8–20/month unless income or deposits maintained",
            requirements: "Passport, proof of address (abroad or in Spain), proof of income; may need non-residency certificate",
            bestFor: "Long-term residents, renting, local transactions",
            note: "Some banks may require a minimum balance or regular transfers"  
          },
            {
            name: "Digital Banks",
            features: "Online-only, mobile-first, low fees",
            fees: "Usually free or minimal",
            requirements: "Passport; NIE/address not always required initially",
            bestFor: "Digital nomads, frequent travelers, tech-savvy users",
            note: "IBAN may be non-Spanish (DE, LT, BE), which can complicate rent or utility payments"
            },
            {
            name: "International Banks",
            features: "Multi-currency accounts, global support",
            fees: "Higher than local banks",
            requirements: "NIE, passport, proof of income/assets",
            bestFor: "Cross-border fund management"
          }
        ]
      },
      faqs: [
        {
          "question": "How do I open a Spanish bank account?",
          "answer": "Most banks require residents to provide NIE, passport, proof of address (empadronamiento) and a proof of income. Non-residents can also open an account using passport, though banks might request a Certificado de no residente (issued in-person by Policía Nacional with EX-15 and Tasa 790 012)."
        },
        {
          "question": "What are the best options for international transfers?",
          "answer": "Digital providers like Wise or Revolut usually offer better exchange rates and lower fees than traditional Spanish banks, which often charge high commissions. Some international banks also provide multi-currency accounts, useful if you move money between Spain and your home country."
        },
        {
          "question": "Do I need Spanish insurance?",
          "answer": "Yes. Private health insurance is required for most visas (non-lucrative, digital nomad, student, entrepreneur). Once you start working and contribute to Spanish Social Security, you can access the public healthcare system."
        },
        {
          "question": "How do I budget effectively in Spain?",
          "answer": "Track your expenses, account for city differences in rent and transport and plan for seasonal costs like summer travel or winter heating. Use our [Cost of Living Calculator](/cost-explorer) to estimate your monthly budget in different Spanish cities."
        },
        {
          "question": "What are typical bank fees in Spain?",
          "answer": "Traditional banks often charge €8–20/month for account maintenance unless you deposit a minimum salary or pension each month. ATM withdrawals are free at your own bank but may have surcharges at others. Digital banks like N26, Revolut or Wise usually offer no monthly fees and lower charges for international use."
        },
        {
          "question": "Will a non-Spanish IBAN (from Revolut, Wise, N26) be accepted in Spain?",
          "answer": "Under SEPA Regulation 260/2012, Spanish companies must accept any SEPA IBAN, but in practice, some might insist on a Spanish IBAN. If you need to set up direct debits for rent, bills, or taxes a traditional Spanish bank account is often required."
        },
        {
          "question": "Can I get a credit card or mortgage as a foreigner in Spain?",
          "answer": "Yes. Residents with income in Spain can apply for credit cards and mortgages. Non-residents may also access mortgages but usually with higher down payments and stricter requirements."
        }
      ],
      relatedHubs: ['taxes', 'cities'],
      entityIds: ['finance', 'banking', 'insurance', 'budgeting', 'transfers', 'wise', 'revolut', 'n26', 'credit-card', 'mortgage', 'sepa-iban', 'sns', 'private-health-insurance']
    },
    {
      id: 'taxes',
      slug: 'taxes',
      title: 'Taxes',
      shortTitle: 'Taxes',
      tagline: 'Tax residency, Beckham Law, and IRPF',
      description: 'Complete tax guide for expats in Spain including Beckham Law, IRPF, Modelo forms, and tax obligations. Understand your tax residency and filing requirements.',
      metaDescription: 'Spanish taxes 2025 for expats: Beckham Law vs IRPF, tax residency rules, deadlines, and Modelo forms. Calculator included.',
      intro: 'Understand tax residency, choose between Beckham Law (24% flat rate) and standard IRPF (progressive rates), and meet filing deadlines. Use our calculator to optimize your tax situation.',
      featuredArticles: ['023', '003','032'],
      featuredTools: ['beckham-law-tax-calculator'],
      comparison: {
          title: "Beckham Law vs Standard IRPF",
        items: [
          {
              "name": "Beckham Law (Special Tax Regime)",
              "eligibility": "New residents moving to Spain for an employment contract, as digital nomads or as company directors (<25% ownership). Condition: not tax resident in Spain during the previous 5 years,",
              "rate": "24% flat up to €600,000; 47% above €600,000",
              "incomeTypes": "Spanish employment income only",
              "deadline": "Opt-in within 6 months of registering with Spanish Social Security",
              "forms": "Form 149 (opt-in), Form 151 (annual return)",
              "bestFor": "Highly-qualified employees, digital nomads, company directors"
            },
            {
              "name": "Standard IRPF",
              "eligibility": "All Spanish tax residents",
              "rate": "Progressive ~19%–47% (state + regional variations)",
              "incomeTypes": "Worldwide income: salary, investments, property, dividends, etc.",
              "deadline": "Annual return by June 30 of the following year",
              "forms": "Form 100 (Modelo de la Renta)",
              "bestFor": "All residents"
          }
        ]
      },
      faqs: [
        {
          question: 'Does foreign income count for Spanish taxes?',
          answer: 'Yes, as a tax resident you must declare worldwide income. However, Beckham Law only taxes Spanish employment income at a 24% flat rate.'
        },
        {
          question: 'When do I need to opt into Beckham Law?',
          answer: 'You must opt into Beckham Law within 6 months of becoming a Spanish tax resident. This is done by filing Form 149.'
        },
        {
          question: 'What are the tax filing deadlines?',
          answer: "Annual tax returns under Beckham Law are filed using Form 151 and standard IRPF with Form 100. Usually they are done April–June with deadline June 30 of the following year."
        },
        {
          question: 'Can I change from Beckham Law to standard IRPF?',
          answer: 'Yes, you can opt out of Beckham Law but you cannot opt back in. Consider this decision carefully as it affects 5 years of taxation.'
        },
        {
          question: 'How long can I stay under the Beckham Law?',
          answer: 'The regime applies from the year of your arrival and the following 5 tax years (a total of 6 years). After this period, you automatically move to the standard IRPF system.'
        },
        {
          question: 'Do I still need to file tax forms under Beckham Law?',
          answer: 'Yes. Even though only Spanish employment income is taxed, you must file an annual return using Form 151. Other information obligations (like Modelo 720 for foreign assets) still apply as per the conditions.'
        },
        {
          question: 'What happens if I am on Beckham Law and earn income above €600,000?',
          answer: 'Income up to €600,000 is taxed at 24%. Income above this threshold is taxed at 47% under the Beckham Law.'
        }
      ],
      relatedHubs: ['visas-permits', 'paperwork'],
      entityIds: ['taxes', 'beckham-law', 'irpf', 'tax-residency', 'modelo-forms', 'modelo-720', 'modelo-100', 'modelo-149', 'modelo-151', 'modelo-150']
    },
    {
      id: 'cities',
      slug: 'cities',
      title: 'Cities',
      shortTitle: 'Cities',
      tagline: 'Compare cost of living and lifestyle',
      description: 'Compare Spain\'s top expat cities: cost of living, rent, climate, job opportunities and lifestyle. Find your perfect Spanish city with our tools.',
      metaDescription: 'Best cities in Spain for expats 2025: compare cost of living, rent, climate, jobs, quality of life and safety. Tools to find your perfect city.',
      intro: 'Compare Spain\'s top expat destinations: Madrid, Barcelona, Valencia, Málaga. Use our City Matcher to find your perfect location based on cost of living, climate, jobs, and lifestyle.',
      featuredArticles: ['027', '004'],
      featuredTools: ['city-matcher', 'cost-explorer'],
      faqs: [
        {
          question: 'Which city is best for families?',
          answer: 'Valencia and Málaga are excellent for families with good schools, affordable housing, and relaxed lifestyle. Madrid and Barcelona offer more international schools but higher costs.'
        },
        {
          question: 'Where are the best tech job opportunities?',
          answer: 'Madrid and Barcelona have the strongest tech scenes. Málaga is growing as a tech hub, while Valencia is popular for remote workers.'
        },
        {
          question: 'Which city has the warmest winters?',
          answer: 'Málaga has the warmest winters with average temperatures of 17°C. Valencia and Barcelona also have mild winters compared to Madrid.'
        },
        {
          question: 'What\'s the most affordable city?',
          answer: 'Málaga and Valencia are the most affordable major cities. Granada and Sevilla offer even lower costs but fewer international amenities.'
        }
      ],
      relatedHubs: ['lifestyle', 'taxes', 'finance'],
      entityIds: ['cities', 'madrid', 'barcelona', 'valencia', 'malaga', 'sevilla', 'palma-de-mallorca', 'bilbao', 'zaragoza', 'alicante', 'gran-canaria', 'granada', 'canary-islands', 'spanish-cities', 'spanish-cities-cost-of-living', 'spanish-cities-rent', 'spanish-cities-climate', 'spanish-cities-jobs', 'spanish-cities-quality-of-life', 'spanish-cities-safety']
    },
    {
      id: 'lifestyle',
      slug: 'lifestyle',
      title: 'Lifestyle',
      shortTitle: 'Lifestyle',
      tagline: 'Healthcare, education, housing & daily life',
      description: 'Complete lifestyle guide for foreign residents and expats in Spain: healthcare, education, housing, culture, daily life and integration in Spain. Adapt to Spanish culture and customs.',
      metaDescription: 'Living in Spain: healthcare options, housing, schools, culture, and integration tips for expats.',
      intro: 'Navigate healthcare registration, find housing, choose schools, and understand Spanish culture. This hub covers everything you need for daily life and integration in Spain.',
      featuredArticles: ['029', '026', '009', '011', '020'],
      featuredTools: ['cost-explorer'],
      comparison: {
            title: "Healthcare in Spain: Public vs Private Insurance",
        items: [
          {
          "name": "Public Healthcare (SNS)",
          "coverage": "Comprehensive care through Spain’s national health system (SNS)",
          "access": "Residents contributing to Social Security, EU pensioners (S1 form), certain categories of residents",
          "cost": "Funded by Social Security contributions where most services are free or have small co-payments",
          "requirements": "Have a social security number and a health card (tarjeta sanitaria)",
          "medication": "Prescription drugs are subsidized 40–90% depending on income and pensioners often pay only 10% capped",
        },
        {
          "name": "Private Health Insurance",
          "coverage": "Fast access to general practitioners and specialists, often with English-speaking staff",
          "access": "Must be purchased, mandatory for most visa types (non-lucrative, student, entrepreneur, etc.) until covered by Social Security",
          "cost": "Premiums vary (€50–€200/month depending on age & coverage)",
          "requirements": "Valid passport/NIE and Spanish bank account.",
          "medication": "Prescription drugs usually not included (some premium policies might offer discounts)",
          "bestFor": "Expats applying for visas, those wanting faster appointments or broader network choice"
          }
        ]
      },
      faqs: [
        {
          question: 'How do I register for healthcare?',
          answer: 'First, register your address at the local town hall (empadronamiento). If you are employed or self-employed, you’ll be enrolled in Social Security and can apply for the health card (tarjeta sanitaria) at your local health center. Non-working residents may access healthcare via private insurance or in some regions, through the Convenio Especial.'
        },
        {
          question: 'What are the best areas to live in each city?',
          answer: 'It would depend on lifestyle. Some noteworthy mentions: Madrid (Salamanca and Chamberí for upscale, Lavapiés and Malasaña for lively). Barcelona (Gràcia and Poble Sec for vibrant culture, Sarrià for families). Valencia (Ruzafa for nightlife or El Carmen for history). Málaga (Pedregalejo for seaside living and the Centro Histórico for city buzz). See our [Cities Guide](/guides/best-cities-in-spain-for-expats-2025-edition) for details.'
        },
        {
          question: 'How do I find international schools?',
          answer: 'Major cities have numerous international schools. Madrid and Barcelona have the most options, while Valencia and Málaga have fewer but growing choices. Bilingual semi-private (concertado) schools also offer English-Spanish education at lower cost than full international schools.'
        },
        {
          question: 'What cultural differences should I expect?',
          answer: 'Later meal times, siesta culture, more relaxed pace, strong family values and a strong sense of regional pride. Learning Spanish is key for integration.'
        }
      ],
      relatedHubs: ['cities', 'paperwork'],
      entityIds: ['lifestyle', 'healthcare', 'education', 'spanish-culture', 'integration', 'public-healthcare', 'private-healthcare', 'sns', 'padron', 'social-security', 'health-card', 'tarjeta-sanitaria', 'health-insurance', 'renting-in-spain', 'buying-in-spain', 'housing-market', 'spanish-culture', 'convenio-especial', 'international-schools', 'concertado']
    },
    {
        id: 'updates',
        slug: 'updates',
        title: 'News & Updates',
        shortTitle: 'News & Updates',
        tagline: 'Latest legal reforms and expat news',
        description: 'Latest immigration, tax, documents, and lifestyle updates for expats in Spain. Stay current with legal reforms, expat news, and featured articles.',
        metaDescription: 'Spain expat updates: visas, taxes, documents, and lifestyle changes. Summaries with sources (BOE/ministry) and FAQs.',
        intro: 'This hub tracks important changes affecting expats in Spain, including visas and permits, taxes, essential documents, and lifestyle rules. Each update links to sources and affected guides/tools.',
        featuredArticles: ['017', '025', '019', '006'],
        featuredTools: [],
        comparison: {
          title: 'Recent Key Changes: Status · Effective Date · Source · Impact',
          items: [
            {
              name: 'RD 1155/2024 - Immigration Reform',
              status: 'Effective',
              impact: 'Work permits up to 4 years, family reunification expanded, student visas allow 30h/week work',
              effective: '2025-05-20',
              source: 'BOE'
            },
            {
              name: 'ETIAS Travel Authorization',
              status: 'Proposed',
              impact: 'New €7 travel authorization required for visa-exempt travelers to Schengen Area',
              effective: '2026-Q4',
              source: 'EU Regulation'
            },
            {
              name: '37.5-Hour Work Week',
              status: 'Proposed',
              impact: 'Reduces legal work week from 40 to 37.5 hours with digital time tracking',
              effective: '2025',
              source: 'Parliament'
            },
            {
              name: '100% Housing Tax',
              status: 'Proposed',
              impact: 'Doubles property transfer tax for non-EU, non-resident buyers of second-hand homes',
              effective: '',
              source: 'Parliament'
            },
            {
              name: 'Vacant Home Tax',
              status: 'Enforced',
              impact: 'Local councils can charge up to 150% more IBI tax on homes vacant over 2 years',
              effective: '2023-Enforced',
              source: 'Housing Law'
            },
            {
              name: 'Immigration Regularization',
              status: 'Proposed',
              impact: 'One-year residence permit for migrants who lived in Spain before March 31, 2025',
              effective: '',
              source: 'Citizen-led initiative'
            }
          ]
        },
        faqs: [
          {
            question: 'How often is the information updated?',
            answer: 'We add significant BOE or ministry changes as often as possible, with summaries, guides, links and tools.'
          },
          {
            question: 'Where do these updates come from?',
            answer: 'Official sources like the BOE, Ministerio de Inclusión and Seguridad Social y Migraciones and Agencia Tributaria.'
          },
          {
            question: 'Can I get notified of new updates?',
            answer: 'Yes. You can subscribe to our newsletter to receive alerts when major reforms, BOE publications or EU rules affecting expats come into effect.'
          }
        ],
        relatedHubs: ['visas-permits', 'taxes', 'paperwork'],
        entityIds: ['updates', 'immigration-reform', 'etias-travel-authorization', '37-5-hour-work-week', '100-housing-tax', 'vacant-home-tax', 'immigration-regularization']
      }
  ],
  
  // Helper function to get hub by slug
  getHubBySlug: function(slug) {
    return this.hubs.find(hub => hub.slug === slug);
  },
  
  // Helper function to get hub by ID
  getHubById: function(id) {
    return this.hubs.find(hub => hub.id === id);
  },
  
  // Helper function to get all hub slugs for routing
  getAllSlugs: function() {
    return this.hubs.map(hub => hub.slug);
  }
};
